import FeatureTile    from '../components/FeatureTile';
import useScrollReveal from '../hooks/useScrollReveal';

import rippleIcon  from '../assets/icons/ripple.svg';
import hintIcon    from '../assets/icons/hint.svg';
import undoIcon    from '../assets/icons/undo.svg';
import fireIcon    from '../assets/icons/fire.svg';
import cupIcon     from '../assets/icons/cup.svg';
import energyIcon  from '../assets/icons/energy.svg';

const FEATURES = [
  { iconSrc: rippleIcon, title: 'Long-press preview',  body: 'Hold any cell to preview its full ripple path before committing — completely free.' },
  { iconSrc: hintIcon,   title: 'Smart hints',          body: 'Stuck? Hint highlights the best next move. Costs +3 taps — use wisely.' },
  { iconSrc: undoIcon,   title: 'Undo anytime',         body: 'Made a wrong move? Undo restores the last board state. Costs +2 taps.' },
  { iconSrc: fireIcon,   title: 'Daily streak',         body: 'Build a streak by solving the daily puzzle every day.' },
  { iconSrc: cupIcon,    title: 'Par system',           body: 'Every puzzle has a Par — the near-optimal solution. Beat it for Gold.' },
  { iconSrc: energyIcon, title: 'Energy system',        body: 'Each game costs energy. It refills +1 every 30 minutes.' },
];

export default function Features() {
  const [ref, visible] = useScrollReveal();

  return (
    <section className="section" style={{ background: 'var(--surface)' }}>
      <div className="container section-content">

        <div ref={ref} className={`reveal ${visible ? 'visible' : ''}`}>
          <h2 className="section-headline">Everything you need</h2>
          <p className="section-sub" style={{ marginTop: 8 }}>
            Tools to help you think deeper, recover from mistakes, and keep coming back.
          </p>
        </div>

        <div className="features-grid">
          {FEATURES.map((feat, i) => (
            <FeatureTile key={feat.title} {...feat} delay={i * 80} />
          ))}
        </div>

      </div>
    </section>
  );
}
